import { AutocompleteInput } from "@/components/admin";
import {
  DataTable,
  List,
  ListActions,
  ReferenceField,
  SearchInput,
  TextField,
} from "../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const DepartmentList = () => (
  <List
    title="Departments"
    filters={filters}
    actions={<ListActions label="Add Department" />}
    sort={{ field: "name", order: "ASC" }}
  >
    <div className="employees-table-container">
      <DataTable rowClick="show" className="employees-table">
        <DataTable.Col source="code" label="Code" className="employee-code" />
        <DataTable.Col source="name" label="Department" className="employee-name" />
        <DataTable.Col label="Head">
          <ReferenceField
            source="head_employee_id"
            reference="employees"
            link={false}
          >
            <TextField source="name" emptyText="-" />
          </ReferenceField>
        </DataTable.Col>
      </DataTable>
    </div>
  </List>
);

export { AutocompleteInput };

